import { siteData } from "../data/siteData";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import logo1 from "../assets/logo1.png";
//import floretqr from '../assets/floretqr.png';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div
          className="grid  md:grid-cols-[1.6fr_1fr]
         lg:grid-cols-[1.6fr_0.75fr_1fr_1.9fr] gap-4 mb-12"
        >
          <div className="min-w-0">
            <Link
              to="/"
              onClick={() => {
                if (window.location.pathname === "/") {
                  window.dispatchEvent(new Event("force-scroll-top"));
                }
              }}
              className="flex items-center space-x-3 mb-4"
            >
              <div className="rounded-lg flex items-center justify-center">
                <img
                  src={logo1}
                  alt={`${siteData.company.name} Logo`}
                  className="w-24 h-18 border-2 p-0 rounded-lg border-gray-400 object-contain"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#C2DF93]">
                  {siteData.company.name}
                </h3>
                <p className="text-xs pb-2 text-[#C2DF93]">
                  by {siteData.company.parentCompany}
                </p>
              </div>
            </Link>

            <p className="text-gray-400 mb-3 text-sm leading-relaxed">
              {siteData.company.tagline}. Experience premium living in harmony
              with nature.
            </p>

            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C2DF93] hover:text-black transition-colors"
              >
                <FaFacebookF size={20} />
              </a>
              <a
                href="https://www.instagram.com/fbgroupinfra/"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C2DF93] hover:text-black transition-colors"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/login"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C2DF93] hover:text-black transition-colors"
              >
                <FaLinkedinIn size={20} />
              </a>
              <a
                href="https://x.com/twitt_login?lang=en"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C2DF93] hover:text-black transition-colors"
              >
                <FaTwitter size={20} />
              </a>
            </div>
            <div className="mt-6">
              <a
                href={siteData.company.parentWebsite}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-[#C2DF93] transition-colors"
              >
                Visit {siteData.company.parentCompany} Website →
              </a>
            </div>
          </div>
          {/*Flex on for mobile view */}
          <div className="flex flex-row sm:hidden justify-between">
            <div className="min-w-0">
              <h4 className="font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {siteData.navigation.map((link) => (
                  <li key={link.id}>
                    <Link
                      to={link.path}
                      onClick={() => {
                        if (window.location.pathname === link.path) {
                          window.dispatchEvent(new Event("force-scroll-top"));
                        }
                      }}
                      className="text-gray-400 hover:text-[#C2DF93] transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="min-w-0">
              <h4 className="font-bold mb-4">Contact</h4>
              <ul className="space-y-3 text-sm text-gray-400">
                <li className="flex items-center space-x-2">
                  <Phone size={16} />
                  <a
                    href={`tel:${siteData.contact.phone}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    {siteData.contact.phone}
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <Phone size={16} />
                  <a
                    href={`tel:${siteData.contact.mobile}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    {siteData.contact.mobile}
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <FaWhatsapp size={16} />
                  <a
                    href={`tel:${siteData.contact.mobile}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <MapPin size={16} className="mt-1 flex-shrink-0" />
                  <span>Outer Ring Road, Lucknow</span>
                </li>
              </ul>
            </div>
          </div>


          <div className="min-w-0 hidden sm:block">
              <h4 className="font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {siteData.navigation.map((link) => (
                  <li key={link.id}>
                    <Link
                      to={link.path}
                      onClick={() => {
                        if (window.location.pathname === link.path) {
                          window.dispatchEvent(new Event("force-scroll-top"));
                        }
                      }}
                      className="text-gray-400 hover:text-[#C2DF93] transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="min-w-0 hidden sm:block">
              <h4 className="font-bold mb-4">Contact</h4>
              <ul className="space-y-3 text-sm text-gray-400">
                <li className="flex items-center space-x-2">
                  <Phone size={16} />
                  <a
                    href={`tel:${siteData.contact.phone}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    {siteData.contact.phone}
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <Phone size={16} />
                  <a
                    href={`tel:${siteData.contact.mobile}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    {siteData.contact.mobile}
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <FaWhatsapp size={16} />
                  <a
                    href={`tel:${siteData.contact.mobile}`}
                    rel="noreferrer"
                    className="hover:text-[#C2DF93] transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
                <li className="flex items-start space-x-2">
                  <MapPin size={16} className="mt-1 flex-shrink-0" />
                  <span>Outer Ring Road, Lucknow</span>
                </li>
              </ul>
            </div>

          


















          <div className="flex flex-col sm:flex-row items-start gap-3 rounded-lg min-w-0">
            <img
              src="https://fbgroupinfra.com/wp-content/uploads/2024/11/Untitled-design-1.png"
              alt="Floret Town RERA QR"
              className="w-[120px] h-[120px] object-contain rounded-md flex-shrink-0"
            />

            <div className="text-sm leading-6 text-gray-300">
              <p>
                <span className="font-semibold text-white">Project Name:</span>{" "}
                FLORET TOWN
              </p>
              <p>
                <span className="font-semibold text-white">
                  Project RERA No:
                </span>{" "}
                UPRERAPRJ535139/04/2025
              </p>
              <p>
                <span className="font-semibold text-white">
                  Promoter RERA No:
                </span>{" "}
                UPRERAPRM347871
              </p>
              <p>
                <span className="font-semibold text-white">Promoter Name:</span>{" "}
                FB INFRA DEVELOPERS LLP
              </p>
              <p>
                <span className="font-semibold text-white">RERA Website:</span>{" "}
                <a
                  href="https://www.up-rera.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-400 underline hover:text-[#C2DF93]"
                >
                  www.up-rera.in
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2026 {siteData.company.name} by {siteData.company.parentCompany}
              . All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <Link
                to="/privacy-policy"
                className="hover:text-[#C2DF93] transition-colors"
              >
                Privacy Policy
              </Link>

              <Link
                to="/terms-and-conditions"
                className="hover:text-[#C2DF93] transition-colors"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
